import React from 'react'

import styles from './email.module.css'
import { useNavigate } from 'react-router-dom'

const Email = () => {
	const navigate = useNavigate()
	return (
		<div className={styles.box}>
			<div className={styles.email}>
				<div className={styles.header}>
					<div className={styles.iconBox}>
						<div className={styles.icon}>
							<div className={styles.month}>Jul</div>
							<div className={styles.day}>22</div>
							<div className={styles.label}>Mon</div>
						</div>
					</div>
					<div className={styles.content}>
						<div className={styles.top}>
							<b>Carles Batllori and Emmanuel Jobim</b>
							<button className={styles.buttonView}>
								View on Google Calendar
							</button>
						</div>
						<ul>
							<li>
								<span>When</span>
								<p>Mon Jul 22, 2024 10am - 10:30am (GMT+2)</p>
							</li>
							<li>
								<span>Where</span>
								<p>Google Meet (instructions in description)</p>
							</li>
							<li>
								<span>Who</span>
								Emmanuel Jobim*
							</li>
						</ul>
						<div className={styles.buttons}>
							<button className={styles.yes}>
								Yes
								<div>
									<svg fill='none' viewBox='0 0 24 24'>
										<path
											stroke='currentColor'
											strokeLinecap='round'
											strokeLinejoin='round'
											strokeWidth='2'
											d='m8 10 4 4 4-4'
										/>
									</svg>
								</div>
							</button>
							<button className={styles.maybe}>Maybe</button>
							<button className={styles.no}>No</button>
							<button className={styles.more}>More options</button>
						</div>
					</div>
					<div className={styles.events}>
						<b>Agenda</b>
						<span>Mon Jul 22, 2024</span>
						<ul>
							<li>
								<span>8:45am</span>
								<a>Analisis de Sang resultats</a>
							</li>
							<li>
								<span>10am</span>
								<a>Carles Batllori and Emmanuel Jobim</a>
							</li>
							<li>
								<a>No later events</a>
							</li>
						</ul>
						<div></div>
					</div>
				</div>
				<div className={styles.container}>
					<div className={styles.left}>
						<div>Event Name: Meeting with Pixelette</div>
						<div>
							Location: This is a Google Meet web conference. You can join this
							meeting from your computer, tablet, or smartphone.
							<a>
								https://calendly.com/events/f806c7de-0af6-43d8-99ec-6cf4302618ce/google_meet
							</a>
						</div>
						<div>
							Need to make changes to this event? Cancel:
							<a>
								https://calendly.com/cancellations/51b751d1-922e-4543-884e-fd0ce28c9a0d
							</a>
							Reschedule:
							<a>
								https://calendly.com/reschedulings/51b751d1-922e-4543-884e-fd0ce28c9a0d
							</a>
							Powered by Calendly.com
						</div>

						<div>
							<b>Cuándo</b>
							lunes 22 de jul de 2024 ⋅ 10am – 10:30am (Hora de Europa central -
							Madrid)
						</div>
						<div>
							<b>Ubicación</b>
							Google Meet (instructions in description)
						</div>
						<a>Ver mapa</a>
						<div>
							<b>Invitados</b>
							<ul>
								<li>Emmanuel Jobim- organizador</li>
								<li>info@FacturaGPT.com</li>
							</ul>
							<a>Ver toda la información de los invitados</a>
							<div>Responder a info@FacturaGPT.com</div>
							<div>
								<button>Sí</button>
								<button>No</button>
								<button>Quizás</button>
								<button>Más opciones</button>
							</div>
						</div>
					</div>
					<div className={styles.right}>
						<button
							onClick={() =>
								navigate(`/es/app/calendar/joinEvent/emw-dhnm-nuw`)
							}
							className={styles.buttonJoin}
						>
							Unirme con Google Meet
						</button>
						<div>
							<b>Enlace de la reunión</b>
							<a>meet.google.com/xsy-wqzc-jib</a>
						</div>
						<div>
							<b>Unirse por teléfono</b>
							<div>
								(ES)
								<a>+34 935 24 91 70</a>
								PIN: 938418776
							</div>
						</div>
						<a>Más números de teléfono</a>
					</div>
				</div>
				<div className={styles.footer}>
					Invitación de
					<a>Google Calendar</a>
					<br />
					Te hemos enviado este correo porque te has suscrito a las
					notificaciones del calendario. Si quieres dejar de recibir estos
					correos, ve a la
					<a>configuración de Calendar</a>
					, selecciona este calendario y cambia "Otras notificaciones".
					<br />
					Si reenvías esta invitación, los destinatarios podrían enviar una
					respuesta al organizador para que los añada a la lista de invitados,
					invitar a otras personas independientemente del estado de su propia
					invitación, o cambiar tu respuesta de confirmación de asistencia.
					<a>Más información</a>
					<br />
				</div>
			</div>
		</div>
	)
}

export default Email
